import { Worker } from "../util";
import moment from "moment";
import FilteredListCtrl from "../common/FilteredListCtrl";

const POZIADAVKY_FILTER_KEY = "antes.poziadavky.list.filter";

export default class PoziadavkaListCtrl extends FilteredListCtrl {

  static resolve = {
    typy: (PoziadavkaService) => PoziadavkaService.getTypes()
  }

  constructor(ZakaznikService, PoziadavkaService, typy) {
    super(false);
    this.ZakaznikService = ZakaznikService;
    this.PoziadavkaService = PoziadavkaService;
    this.order = {
      mtime: false
    };

    this.filterOptions = {
      stav: [
        { value: undefined, label: "Akýkoľvek stav" },
        { value: -1, label: "Neuzavretá" },
        { value: 0, label: "Otvorená"},
        { value: 1, label: "Riešená"},
        { value: 2, label: "Čaká na zákazníka"},
        { value: 3, label: "Na uzavretie"},
        { value: 4, label: "Uzavretá"},
      ],
      typId: [
        { value: undefined, label: "Všetky typy"}
      ].concat(typy.map(typ => ({value: typ.id, label: typ.nazov}))),
      vztah: [
        {value: undefined, label: "Všetky"},
        {value: "AUTHOR", label: "Požiadavky, ktoré som založil"},
        {value: "ANY", label: "Požiadavky, ktoré sa ma týkajú"},
      ],
      zakaznik: [{label: "Všetci zákazníci", value: undefined}, {label: "Žiaden zákazník", value: null}]
    };
    if(ZakaznikService){
      ZakaznikService.list().then(zakaznici => {
        this.filterOptions.zakaznik = [{label: "Všetci zákazníci", value: undefined}, {label: "Žiaden zákazník", value: null}].concat(
          zakaznici.map(zakaznik => ({
            label: zakaznik.nazov,
            value: zakaznik.id
          }))
        );
      });
    }

    //this.loadFilter(POZIADAVKY_FILTER_KEY);
    this.load();
  }

  getEmptyFilter() {
    return {
      stav: -1,
      typId: undefined
    };
  }

  _load() {
    var sortOrder = [];
    // @TODO prerobit cely sort na format [{column: "tlpec", dir: true|false}, ...]
    if(this.order.ctime !== undefined){
      sortOrder.push({column: "ctime", dir: this.order.ctime});
    }
    if(this.order.mtime !== undefined){
      sortOrder.push({column: "mtime", dir: this.order.mtime});
    }
    return this.PoziadavkaService.list(this.filter, sortOrder).then(poziadavky => this.show(poziadavky.result));
  }

  toggleOrder(key){
    if(this.order[key]){
      this.order = {};
      this.order[key] = false;
    }else{
      this.order = {};
      this.order[key] = true;
    }
    this.loadPoziadavky();
  }

  isLate(poziadavka){
    return poziadavka.stav!=4 && moment(poziadavka.mtime || poziadavka.ctime).add(5, "days").isBefore(moment());
  }


}


// WEBPACK FOOTER //
// ./src/poziadavky/PoziadavkaListCtrl.js